<span *ngIf="is_modal; then thenBlock; else elseBlock"></span>
<ng-template #thenBlock>
  <dentr-modal>
    <div #modalScroll>
      <ng-container *ngTemplateOutlet="privacy"></ng-container>
      <button class="btn-secondary w-full sm:w-auto" (click)="closeModal()">Close</button>
    </div>
  </dentr-modal>
</ng-template>
<ng-template #elseBlock>
  <ng-container *ngTemplateOutlet="privacy"></ng-container>
</ng-template>
<ng-template #privacy>
  <h2 class="heading-xxl mb-4 mt-4">Privacy Policy</h2>
  <ng-container *ngComponentOutlet="selectedPolicyComponent"></ng-container>
</ng-template>
